const dauMaxRange = 365;

export default {
    dauMaxRange,
};
